import {compose} from 'redux';
import {connect} from 'react-redux';
import {Field, reduxForm, SubmissionError} from 'redux-form';
import {Button, Form, Message, Segment} from 'semantic-ui-react';
import {useToasts} from 'react-toast-notifications';
import FormInput from '../shared/forms/input';
import {password, required} from '../shared/forms';
import {updatePasswordRequest} from '../../redux/actions/user';

function UpdatePasswordForm(props) {
  const {handleSubmit, pristine, submitting, error} = props;
  const {addToast} = useToasts();

  async function submit({password}) {
    try {
      await props.updatePasswordRequest(password);
      addToast('رمز عبور شما با موفقیت تغییر کرد.', {appearance: 'success'});
    } catch (error) {
      const errorMessage = error.message || 'تغییر رمز عبور انجام نشد.';
      throw new SubmissionError({_error: errorMessage});
    }
  }

  return (
    <Segment>
      {/*form error*/}
      {(error && !pristine) && (
        <Message
          error
          header={error}
          className={'text-center'}
        />
      )}

      {/*form*/}
      <Form onSubmit={handleSubmit(submit.bind(null))}>
        <Field
          required
          name='password'
          type='password'
          label='رمز عبور جدید'
          component={FormInput}
          validate={[required, password]}
        />
        <Field
          required
          name='password2'
          type='password'
          label='تکرار رمز عبور جدید'
          placeholder='رمز عبور جدید خود را مجدد وارد نمایید'
          component={FormInput}
          validate={[required, password]}
        />
        <Button
          type='submit'
          disabled={pristine || submitting}
          content='تغییر رمز عبور'
        />
      </Form>
    </Segment>
  );
}

function validate(values) {
  const errors = {};
  if (values.password !== values.password2) errors.password2 = 'رمزهای عبور غیر یکسان هستند.';
  return errors;
}

export default compose(
  connect(null, {updatePasswordRequest}),
  reduxForm({form: 'update-password', validate})
)(UpdatePasswordForm);
